module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/technical/project-design-issue-type/design-issue-type-grid/design-issue-type-grid.component.css
// module id = ./src/app/technical/project-design-issue-type/design-issue-type-grid/design-issue-type-grid.component.css
// module chunks = main